<script lang="ts">
  import EditableText from './EditableText.svelte';
  import Provenance from './Provenance.svelte';
  import type { BlockTable, RenderCtx } from './types';

  let { block, ctx, editing = false, onchange }: {
    block: BlockTable;
    ctx: RenderCtx;
    editing?: boolean;
    onchange?: (next: BlockTable) => void;
  } = $props();

  function edit(row: number, col: number, text: string) {
    onchange?.({
      ...block,
      rows: block.rows.map((cells, r) =>
        r === row ? cells.map((cell, c) => (c === col ? { ...cell, text } : cell)) : cells),
    });
  }
</script>

<table class="brf-t">
  <thead>
    <tr>{#each block.columns as column, c (c)}<th scope="col">{column}</th>{/each}</tr>
  </thead>
  <tbody>
    {#each block.rows as cells, r (r)}
      <tr>
        {#each cells as cell, c (c)}
          <td class:emph={!!cell.emphasis} data-emphasis={cell.emphasis}
            ><EditableText value={cell.text} {editing}
               ariaLabel="{block.columns[c] ?? `Column ${c + 1}`}, row {r + 1}"
               onchange={(text) => edit(r, c, text)} /><Provenance
               provenance={cell.provenance} sourceIds={cell.source_ids} {ctx} /></td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>
{#if block.provenance}
  <p class="brf-t-prov"><Provenance provenance={block.provenance} sourceIds={block.source_ids} {ctx} /></p>
{/if}
